import { cva } from 'class-variance-authority';

import s from './SelectButton.module.css';

export const selectButtonVariants = cva(s.selectButton, {
  defaultVariants: {
    fullWidth: false,
  },
  variants: {
    fullWidth: {
      true: s['select--full-width'],
    },
  },
});
